import type { HostProductCodeDto } from "../../types/HostProductCodeDto";
import type { HostProductCodeEntity } from "../../types/HostProductCodeEntity";

export const HostProductCodeDtoToEntity = ({ ...rest }: Readonly<HostProductCodeDto>): HostProductCodeEntity => {
    return { ...rest };
};
